/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import PubSub from 'pubsub-js';
import keyboard from 'keycode-ui';

/*---------------------------------------------------------*\
 * PollController
\*---------------------------------------------------------*/
class PollController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($location, topics, navigationService, pollsService, localService, storageKeys, adProps) {
    this.name = 'poll';
    this.navigationService = navigationService;
    this.pollsService = pollsService;
    this.localService = localService;
    this.storageKeys = storageKeys;
    this.adProps = adProps;

    // Todo remove $location ref at some point
    this._showResults = !!$location.search().pollResults;

    this.loading = true;

    pollsService.getQuestion(this.region).then((data) => {
      this.data = data.data.pollquestion;
      this.loading = false;

      this.navigationService.focusElAsync('.poll-vote');
    });

    this.onListItemClick = (event) => {
      this.loading = true;

      pollsService.postVote(this.data.pollid, event.item.id).then((data) => {
        this.result = data.data.pollquestion;
        this.showResults = true;
        this.loading = false;
      });
    };

    this.listPrevComponentHandler = (index, up) => {
      if (up) {
        this.onKeydown({
          isEventUp: up
        });
      }
    };

    this.listNextComponentHandler = (index, down) => {
      PubSub.publish(down ? topics.nav.down : topics.nav.right, 'poll-list');
    };

    this.resultsBlockLeft = (e) => {
      if (keyboard.isLeft(e)) {
        e.preventDefault();
        e.stopPropagation();
      } else if (keyboard.isDown(e)) {
        const previousElement = e.target;
        PubSub.publish(this.adProps.home.previousElement, { previousElement });
      }
    };

    this.mainBlockLeft = (e) => {
      if (keyboard.isDown(e) || keyboard.isRight(e)) {
        const previousElement = e.target;
        PubSub.publish(this.adProps.home.previousElement, { previousElement });
      }
    };
  }

  //-----------------------------------
  // Properties
  //-----------------------------------
  set showResults(value) {
    this._showResults = value;

    if (this._showResults) {
      this.navigationService.focusElAsync('.main-menu-btn');
    }
  }

  get showResults() {
    return this._showResults;
  }

  get region() {
    const _region = this.localService.get(this.storageKeys.selectedRegion);

    return _region ? _region.abbr : 'LI';
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  resultsSelect() {
    this.loading = true;

    this.pollsService.getResults(this.data.pollid).then((data) => {
      this.result = data.data.pollquestion;
      this.showResults = true;
      this.loading = false;
    });
  }

  showMain() {
    if (this.onExit) {
      this.onExit();
    }
  }
}

PollController.$inject = [
  '$location',
  'topics',
  'navigationService',
  'pollsService',
  'localService',
  'storageKeys',
  'adProps'
];

export default PollController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/poll/poll.controller.js
 **/